export const FileConstants = {
    GettingStarted: "linkquickstartguide.pdf",
};
